import React, { useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import showAlert from "utils/showAlert";

export default function CreateFirstAccountModal(props) {
  console.log(props);

  const org = props.org;
  const defaultLogo = require("images/lite/icons/logo-placeholder.png");
  const orgLogoUrl = props.org_logo ? props.org_logo : `/datapulse${defaultLogo}`;
  const orgLogo = <img src={orgLogoUrl} alt="Organization Logo" className="org-logo" />;

  const [isModalVisible, setIsModalVisible] = useState(props.show || false);

  const hideModal = () => setIsModalVisible(false);

  const copyInviteCode = () => {
    navigator.clipboard.writeText(org.invite_code);
    showAlert("Invite code copied to clipboard!", "success");
  };

  const showCreateAccountForm = () => {
    hideModal();
    props.showCreateModal();
  };

  return (
    <>
      <Modal show={isModalVisible} onHide={hideModal} className="create-account-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="logo-display">{orgLogo}</div>
            <h4>{org.name} is in the building!</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4 create-account-cards">
            <div className="create-account-card">
              <b>Watch this short video to learn about DataPulse and how to use it:</b>
              <div className="video-section">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/jpb3I9NZ5WM?si=3hoUT1TdqO8feOou"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
            <div className="create-account-card">
              <b>Here's your join code to invite your team to your organization:</b>
              <div className="invite-code-section">
                <h4 className="invite-code">{org.invite_code}</h4>
                <button className="copy-icon" onClick={copyInviteCode}>
                  <img src={`/datapulse${require("images/lite/icons/paste.png")}`} alt="Copy Icon" className="filter-grey" />
                </button>
              </div>
              <p className="note">
                Note: You can find your invite code again at any time by clicking your avatar in the top-right, and clicking the organization dropdown, then
                going to <a href={`/datapulse/organizations/${org.id}`}>Organization Settings</a>.
              </p>
            </div>

            <div className="create-account-card">
              <h5>Your first step is creating a company account. DataPulse can hold multiple accounts per organization.</h5>
              <ul>
                <li>If you're an agency looking to track clients' metrics, this allows you to have separate dashboards for every client company account.</li>
                <li>If you're a business only interested in tracking your own metrics, you'll likely just need to make a single account for your company.</li>
              </ul>

              <div className="create-account-buttons">
                <button type="button" className="button b-size-normal skip-button" onClick={hideModal}>
                  Skip for now
                </button>
                <button type="button" className="button b-type-primary b-size-normal b-color-green create-first-account-button" onClick={showCreateAccountForm}>
                  <img className="filter-white" src={`/datapulse${require("images/lite/icons/overview.svg")}`} alt="Create Account Icon" />
                   Create your first account
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
